var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header"},[(_vm.back.length)?_c('div',{staticClass:"header__arrow",on:{"click":function($event){return _vm.$router.push(_vm.back)}}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }